export const REGULATORY_LOGOS = [
  { src: '/regol/footer-kemenperin.png', alt: 'Kementerian Perdagangan Republik Indonesia', label: 'Kemenperin' },
  {
    src: '/regol/footer-ojk.png',
    alt: 'Otoritas Jasa Keuangan',
    label: 'OJK',
    sizeClass: 'prod-auth__regulatory-logo--emphasis',
  },
  {
    src: '/regol/footer-bi.png',
    alt: 'Bank Indonesia',
    label: 'BI',
    sizeClass: 'prod-auth__regulatory-logo--emphasis',
  },
  { src: '/regol/footer-jfx.png', alt: 'Jakarta Futures Exchange', label: 'JFX' },
  { src: '/regol/footer-kbi.png', alt: 'Kliring Berjangka Indonesia', label: 'KBI' },
] as const
